export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7726.91b3ddd8.jpg";